/**
 * The global state selectors
 */

import { createSelector } from 'reselect';

const selectGlobal = state => state.get('global');

const selectRoute = state => state.get('route');

const makeSelectLocation = () =>
  createSelector(selectRoute, routeState => routeState.get('location').toJS());

const makeSelectAuthRedirect = () =>
  createSelector(selectRoute, routeState => {
    const authRedirect = routeState.get('authRedirect');
    return authRedirect && authRedirect.toJS();
  });

const makeSelectLocationState = () =>
  createSelector(makeSelectLocation(), selectLocation =>
    selectLocation.state ? selectLocation.state : undefined
  );

const makeSelectLocationError = () =>
  createSelector(makeSelectLocationState(), state =>
    state && state.error ? state.error : undefined
  );

const makeSelectSuppressSecondaryContent = () =>
  createSelector(selectGlobal, globalState =>
    globalState.get('suppressSecondaryContent')
  );

const makeSelectCasinoSoundsOn = () =>
  createSelector(selectGlobal, globalState =>
    globalState.get('casinoSoundsOn')
  );

export {
  selectGlobal,
  makeSelectLocation,
  makeSelectAuthRedirect,
  makeSelectLocationError,
  makeSelectSuppressSecondaryContent,
  makeSelectCasinoSoundsOn
};
